import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import styles from './detail.module.css';
import { useI18n } from '../i18n/I18nProvider';
export { default as detailStyles } from './detail.module.css';
export function BackLink({ to, children }: { to: string; children: ReactNode }) { return <Link to={to} className={styles.back}><ArrowLeft size={14} />{children}</Link>; }
export function DetailPanel({ title, icon: Icon, action, children, className = '' }: { title: string; icon?: LucideIcon; action?: ReactNode; children: ReactNode; className?: string }) {
  const { t } = useI18n();
  return <section className={`${styles.panel} ${className}`}><header><h2>{Icon && <Icon size={17} />}{t(title)}</h2>{action}</header>{children}</section>;
}
export interface ActivityEvent { id: string; title: string; detail: ReactNode; date: string; tone?: 'green' | 'blue' }
export function ActivityTimeline({ items }: { items: ActivityEvent[] }) {
  return <ol className={styles.timeline}>{items.map(item => <li key={item.id}><i className={item.tone === 'green' ? styles.greenDot : ''} /><div><strong>{item.title}</strong><p>{item.detail}</p></div><time>{item.date}</time></li>)}</ol>;
}
